export const UserMeIT = [
  [
    {
      balloon: '<span class="emoji">😳</span> Cos’è successo, cos’ho fatto?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😭</span> Sì… Hai ragione, come posso rimediare?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😰</span> Ma dai, Marte è solo un viaggetto!'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😍</span>'
    }
  ],
  [
    {
      balloon: 'Con il cibo?'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🤐</span>',
      toggleAvatar: true
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😱</span>'
    }
  ],
  [
    {
      balloon: 'Nutrire chi ha fame, ovviamente! <span class="emoji">💁</span>'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🙀</span>'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🤔</span> Le macchine non consumano cibo...'
    }
  ],
  [
    {
      balloon: '<span class="emoji">😑</span> Che cosa?!? Questi indovinelli sono impossibili!'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🙋</span> Allora come possiamo risolverli?'
    }
  ],
  [
    {
      balloon: 'Ok! Prendo appunti! <span class="emoji">✍️</span>'
    }
  ],
  [
    {
      balloon: '<span class="emoji">🎉</span> Grazie a tutti per aver unito le forze e aver risolto i nostri problemi!'
    }
  ],
  [
    {
      balloon: 'Risolvere tutti questi problemi mi sta facendo venire fame, possiamo fare uno spuntino?'
    }
  ],
  [
    {
      balloon: 'Ok, continuiamo!'
    }
  ],
  [
    {
      balloon: 'Andiamo!'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '/s'
    }
  ],
  [
    {
      balloon: '<span class="emoji">✌</span> Ho già fatto le valigie!'
    }
  ],
  [
    {
      balloon: 'Ok, andiamo!'
    }
  ],
  [
    {
      balloon: 'Ok, continuiamo!'
    }
  ],
  [
    {
      balloon: '🙌 Senz’altro! '
    }
  ],
  [
    {
      balloon: '🥺 Il nostro futuro? '
    },
    {
      balloon: 'Allora mi perdoni? 🥺'
    }
  ]
]
